module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 1995
// module chunks = 184662623972074